// NEEDS TO WORK WITH body selector because dynamic woocommerce html load

function AmountBlock($amountBlock) {
    // INIT
    this.$amountBlock = $amountBlock;
    this.maxTicketsToShow = 50;
    this.$select = this.$amountBlock.find('select');

    this.initSelectric();
    this.listener();
    this.refresh();
}

AmountBlock.prototype.listener = function() {
    this.$amountBlock.on('AmountBlock:refresh', this.refresh.bind(this));
};

AmountBlock.prototype.getMaxAttr = function() {
    // use attr because of cache in data()
    return parseInt(this.$amountBlock.attr('data-max'), 10);
};

AmountBlock.prototype.initSelectric = function() {
    this.$select.selectric({
        arrowButtonMarkup: '<div class="button icon icon-arrow-down-purple"></div>'
    });
};

// This is a optional data attr to pre select inputs
AmountBlock.prototype.getSelectedVal = function() {
    return parseInt(this.$amountBlock.attr('data-selected'), 10);
};

AmountBlock.prototype.generateOptionDom = function() {
    var maxAttr = this.getMaxAttr();
    var selectedVal = this.getSelectedVal();

    if (maxAttr > this.maxTicketsToShow) {
        maxAttr = this.maxTicketsToShow;
    }

    var html = '';

    for (var i = 1; i <= maxAttr; i++) {
        var selectedAttr = selectedVal === i ? 'selected' : '';
        html += '<option ' + selectedAttr + ' value="' + i + '">' + i + '</option>';
    }

    return html;
};

AmountBlock.prototype.refresh = function() {
    var dom = this.generateOptionDom();
    this.$select.html(dom);
    this.$select.selectric('refresh');
};

var amountBlock = {
    init: function() {
        var _this = this;

        // woocoommerce updates certain parts with ajax so make instances again after
        $(document.body).on('updated_wc_div', function() {
            _this.makeInstances();
        });

        _this.makeInstances();
    },

    makeInstances: function() {
        $('.amount-block').each(function() {
            new AmountBlock($(this));
        });
    }
};
